var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Teleport',{attrs:{"to":"#__xt"}},[_c('vue-final-modal',_vm._g(_vm._b({scopedSlots:_vm._u([{key:"default",fn:function({ params, close }){return [_c('div',{staticClass:"modal__content"},[_vm._t("default",null,{"params":params})],2)]}}],null,true)},'vue-final-modal',_vm.mergedProps,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }